import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import { cancellationCartApi } from '@reducers/order/order';

export const EmptyCancellationCartModal = () => {
  const { login } = useSelector((state) => state.auth.user);
  const [show, setShow] = useState(false);
  const [trigger] = cancellationCartApi.useClearCartMutation();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Button size="sm" variant="didxl" onClick={handleShow}>
        Empty basket
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Cancellation cart</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure to empty the cancellation basket?</Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="didxl" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            variant="didxl"
            onClick={() => {
              trigger({ login })
                .unwrap()
                .then(() => {
                  handleClose();
                });
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
